import { createGetContractBasedDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from '../../cp-xhr';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { RateCharge } from '@cp-mx/common';

const { reducer: RateChargePFPReducer, fetchData: fetchDataPFP } = createGetContractBasedDataFetchSlice<
    RateCharge,
    DefaultBusinessMarketApiErrorCode
>({
    dataName: 'rateChargePFP',
    fetchCallback(link: string) {
        return CpDataApi.get(link).then(response => response.data);
    },
});

export default RateChargePFPReducer;
export const fetchRateChargePFP = fetchDataPFP;
